<script>
    // 허브 카드 아이콘 고르기(저작 화면) — 학습자 격자 카드의 아이콘 상자에 들어갈 그림(BOT_CHATS.THUMB_ASSET_ID).
    // 같은 그림이 **허브에서 연 채팅의 헤더**(제목 왼쪽)에도 들어간다(CHAT hubApi.fetchHubLook).
    // 본 콘텐츠 카드(HubPickedCard)와 사전·사후 테스트 자리(HubTestSlot)가 같이 쓴다.
    //
    // ⚠️ 고르는 창(ImagePicker)은 부모(HubChatPicker)에 하나만 둔다 — 카드마다 두면 창이 카드 수만큼 생긴다.
    //    여기는 'pick'/'clear' 만 올린다.
    // ⚠️ 미리보기 상자 색은 허브 기본값(PROFILE hub.css --hub-icon-bg)과 같게 둔다 — 학습자 화면에서 보일 모양 그대로.
    import { createEventDispatcher } from "svelte";
    import { Button } from "../../lib/ui";

    export let iconUrl = null;
    // 아이콘이 없을 때 학습자 화면이 대신 쓰는 것(챗 프로필 사진) — 안내 문구에만 쓴다
    export let fallbackUrl = null;
    // 어디에 보이나 — "card"(격자 카드 + 채팅 헤더) | "header"(채팅 헤더만 — 사전·사후 테스트는 격자 카드가 없고
    // [시작하기] 버튼으로 나온다, PROFILE HubLayout). 그림·저장 칸은 같고 이름·안내만 다르다.
    export let usage = "card";

    const dispatch = createEventDispatcher();
</script>

<div class="tw-space-y-1">
    <span class="tw-block tw-text-xs tw-font-medium tw-text-muted-foreground">{usage === "header" ? "헤더 아이콘" : "카드 아이콘"}</span>
    <div class="tw-flex tw-items-center tw-gap-2">
        <button type="button"
                class="tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[10px] tw-bg-[#cfeabb] hover:tw-ring-2 hover:tw-ring-ring"
                title="이미지 자산에서 고르기" aria-label="카드 아이콘 고르기" on:click={() => dispatch("pick")}>
            {#if iconUrl}
                <img class="tw-h-[30px] tw-w-[30px] tw-object-contain" src={iconUrl} alt="" loading="lazy" />
            {:else}
                <svg class="tw-h-4 tw-w-4 tw-text-[#4eba1d]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14" /><path d="M12 5v14" /></svg>
            {/if}
        </button>
        <Button variant="outline" size="sm" on:click={() => dispatch("pick")}>{iconUrl ? "바꾸기" : "고르기"}</Button>
        {#if iconUrl}
            <Button variant="ghost" size="sm" on:click={() => dispatch("clear")}>지우기</Button>
        {/if}
    </div>
    <span class="tw-block tw-text-xs tw-text-muted-foreground">
        {#if usage === "header"}
            {#if iconUrl}허브에서 연 이 채팅의 헤더(제목 왼쪽)에 들어갑니다.
            {:else}허브에서 연 이 채팅의 헤더에 들어갈 그림이에요. 비워 두면 채팅 프로필 사진이 들어갑니다.{/if}
        {:else if iconUrl}학습자 격자 카드의 아이콘 상자와, 허브에서 연 채팅의 헤더에 들어갑니다.
        {:else if fallbackUrl}비워 두면 채팅 프로필 사진이 들어갑니다. 배경이 투명한 png 를 권해요.
        {:else}비워 두면 제목 첫 글자가 들어갑니다. 배경이 투명한 png 를 권해요.{/if}
    </span>
</div>
